module.exports = __webpack_public_path__ + "static/img/statusonline.d3815e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pdd/statusonline.png
// module id = 1268
// module chunks = 0